<template>
    <VJoyBlockSkeleton class="search-title-skeleton" height="25px" width="30%" data-testid="search-title-skeleton" />
</template>

<script setup lang="ts">
    import {VJoyBlockSkeleton} from '@maltjoy/core-vue';
</script>

<style scoped lang="scss">
    .search-title-skeleton {
        margin: 0;
    }
</style>
